import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { messagesApi } from '../api/messagesApi';

/** Server-side inbox filter (Archived / Awaiting-response tabs). Default fetch = open, not-awaiting. */
export interface SmsInboxFilter {
  status?: string;
  awaiting_response?: boolean;
}

export function useSmsInbox(filter?: SmsInboxFilter, enabled = true) {
  const filterKey = filter?.status ?? (filter?.awaiting_response ? 'awaiting' : 'default');
  return useQuery({
    // Prefix stays `keys.sms.inbox` so mutation invalidations still hit every variant.
    queryKey: [...keys.sms.inbox, filterKey],
    queryFn: ({ signal }) => messagesApi.getInbox(filter, { signal }),
    staleTime: 30_000,
    refetchInterval: 30_000,
    enabled,
  });
}

export { usePatchConversation } from './useSmsMutations';
